import { render } from "./RugbyTeamInsights.vue?vue&type=template&id=ad014340&scoped=true"
import script from "./RugbyTeamInsights.vue?vue&type=script&lang=js"
export * from "./RugbyTeamInsights.vue?vue&type=script&lang=js"

import "./RugbyTeamInsights.vue?vue&type=style&index=0&id=ad014340&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad014340"]])

export default __exports__